/**
 * Click-to-sort helpers for the Sliding Statistics → Top users DataGrid
 * (Score, Completed, Updated).
 */

export const TOP_USERS_SORT_FIELDS = ["score", "completed", "updatedAt"];

export const DEFAULT_TOP_USERS_SORT = { field: "score", dir: "desc" };

export function topUsersSortModel(field = DEFAULT_TOP_USERS_SORT.field, dir = DEFAULT_TOP_USERS_SORT.dir) {
    const sortField = TOP_USERS_SORT_FIELDS.includes(field) ? field : DEFAULT_TOP_USERS_SORT.field;
    const sortDir = dir === "asc" ? "asc" : "desc";
    return [{ field: sortField, sort: sortDir }];
}

export function parseTopUsersSortModel(model) {
    const next = Array.isArray(model) && model.length > 0 ? model[0] : null;
    const field = TOP_USERS_SORT_FIELDS.includes(next?.field)
        ? next.field
        : DEFAULT_TOP_USERS_SORT.field;
    const dir = next?.sort === "asc" ? "asc" : "desc";
    return { field, dir };
}
